import React, { useContext, useEffect, useState } from 'react';
import StudyCard from '../studiesPage/studyPage';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { styled } from '@mui/system';
import StudyFormForUser from '../../pages/studyFormForUser/studyFormUser'
import ActivityPageForUser from '../../pages/activityPageForUser/activityPageForUser'
import EmailForm from '../emailPage/emailPage';
import FileUploadComponent from '../studyDocuments/studyDocument';
import ParticipantList from '../participantList/participantList';
import ActiveStudyStatus from '../ActiveStudyStatus/ActiveStudyStatus';
import StudyFormForAdmin from '../studyFormForAdmin/studyFormForAdmin';
import ActiveStudyFormForUser from '../ActiveStudyFormForUser/ActiveStudyFormForUser';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import UserContext from '../../Context/User/userContext.jsx';

const StyledTab = styled(Tab)({
    fontSize: '1.1rem',
    fontWeight: '600', // Increased label size
    // fontFamily: 'monospace',
    color: '#008B8B', // Default color
    '&:hover': {
        color: '#169a8f', // Change color to yellow on hover
    },
    '&.Mui-selected': {
        color: '#169a8f', // Change color to blue for the active tab
    },
    paddingLeft: '10px',
    marginRight: '50px', // Add spacing between tabs
    fontFamily:'nunito'

});


const StyledTabList = styled(TabList)({
    background: '#E0F2F1', /* Fallback for old browsers */
    background: '-webkit-linear-gradient(to left, #B2DFDB, #E0F2F1)', /* Chrome 10-25, Safari 5.1-6 */
    background: 'linear-gradient(to left, #B2DFDB, #E0F2F1)', /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    backgroundColor: '#ffffff', // Background color
    color: '#169a8f',
    display: 'flex', // Flexbox display
    justifyContent: 'around', // Centering tabs
    alignItems: 'center' // Aligning items vertically
});



function MainStudy({ setShowSpinner }) {
    const { id } = useParams();
    const [value, setValue] = React.useState('1');
    const [data, setData] = useState([]);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [isAdmin, setIsAdmin] = useState(false);


    // Bearer Token
    const token = localStorage.getItem('token');
    const tokenValue = token ? token.slice(1, token.length - 1) : ""

    // User Object
    const { user, setUser } = useContext(UserContext);
    const _id = user && (typeof user === 'string' ? JSON.parse(user)._id : user._id);
    const validateAdmin = () => {
        axios.get(`https://research-mate-b35a10757d5a.herokuapp.com/api/auth/validateAdmin/${_id}`, {
            headers: {
                'Authorization': `Bearer ${tokenValue}`
                // You can add other headers if needed like authorization token, etc.
            }
        })
            .then(res => {
                const adminExist = res.data.success;
                setIsAdmin(adminExist);
            })
            .catch(error => {
                console.error("Error:", error.response.data.message);
            });
    }

    const getData = () => {
        axios.post(`https://research-mate-b35a10757d5a.herokuapp.com/api/adminStudy/specific`,
            {
                _id: id
            }, {
            headers: {
                'Authorization': `Bearer ${tokenValue}`
                // You can add other headers if needed like authorization token, etc.
            }
        })
            .then(res => {
                const response = res.data.data
                setData(response);
            })
            .catch(error => {
                console.log(error.response?.data?.message);
            })
            .finally(() => {
                setShowSpinner(false);
            })
    }

    useEffect(() => {
        if (user) {
            validateAdmin()
            getData()
        }
    }, [user])


    return (
        <div className='p-4'>
            <div className='d-flex align-items-center'>
                <div>
                    <h4 style={{color:'rgb(23 131 131)'}}>Study Title : {data &&  data[0]?.title}/{data[0]?.studyCode}</h4>
                </div>
                <div>
                    <h6 style={{ color: 'red', marginLeft: '5px' }}>({data[0] && data[0].status})</h6>
                </div>
            </div>
            <div>
                <StudyCard id={id} setShowSpinner={setShowSpinner} />
            </div>
            {
                isAdmin ?
                    <div className='mt-2'>
                        <Box sx={{ width: '100%', typography: 'body1' }}>
                            <TabContext value={value}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <StyledTabList onChange={handleChange} aria-label="lab API tabs example">
                                        <StyledTab label="Study" value="1" />
                                        <StyledTab label="Documents" value="2" />
                                        <StyledTab label="Email" value="3" />
                                        <StyledTab label="Activity" value="4" />
                                        <StyledTab label="Participant" value="5" />
                                        <StyledTab label="status" value="6" />
                                    </StyledTabList>
                                </Box>
                                <TabPanel value="1"><StudyFormForAdmin data={data} /></TabPanel>
                                <TabPanel value="2"><FileUploadComponent setShowSpinner={setShowSpinner} studyData={data} /></TabPanel>
                                <TabPanel value="3"><EmailForm /></TabPanel>
                                <TabPanel value="4"><ActivityPageForUser setShowSpinner={setShowSpinner} data={data} /></TabPanel>
                                <TabPanel value="5"><ParticipantList setShowSpinner={setShowSpinner} id={id} adminStudy={data} /></TabPanel>
                                <TabPanel value="6"><ActiveStudyStatus setShowSpinner={setShowSpinner} id={id} /></TabPanel>

                            </TabContext>
                        </Box>
                    </div>
                    :
                    <ActiveStudyFormForUser setShowSpinner={setShowSpinner} data={data} />
            }
        </div>
    );
}

export default MainStudy;
